import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { useTranslations } from 'next-intl';

const LegalDisclaimer = () => {
  const t = useTranslations();
  return (
    <Typography className="mt-40 mb-12">
      {t('legal_disclaimer_translations')}
    </Typography>
  );
};

export default LegalDisclaimer;
